import Swal from "sweetalert2";

export default function getSwalInterruptLoading() {
  return Swal.fire({
    icon: "error",
    title: "Oops...",
    text: "Al momento non è stato possibile scaricare l'immagine, riprovare più tardi!",
  });
}
